// extracted by mini-css-extract-plugin
export default {"container":"container__XBZq0_kt","icon":"icon__zjmAWv7h","title":"title__rU8zhEyV","body":"body__KZpSa2Ja"};